const DEFAULT_API_PORT = process.env.REACT_APP_API_PORT || '5000'
const LOOPBACK_HOSTS = new Set(['localhost', '127.0.0.1', '[::1]', '::1'])

// When the app is opened from a phone on the LAN it is served from the PC's IP,
// where "localhost" would resolve to the phone itself, so reuse the page host.
function resolveApiRoot() {
  const pageHostname = window.location.hostname
  const configured = (process.env.REACT_APP_API_URL || '').trim()

  if (!configured) {
    return `${window.location.protocol}//${pageHostname}:${DEFAULT_API_PORT}`
  }

  try {
    const configuredUrl = new URL(configured)
    if (
      LOOPBACK_HOSTS.has(configuredUrl.hostname) &&
      !LOOPBACK_HOSTS.has(pageHostname)
    ) {
      configuredUrl.hostname = pageHostname
      configuredUrl.protocol = window.location.protocol
      return configuredUrl.toString()
    }
    return configured
  } catch {
    return configured
  }
}

export const API_ROOT = resolveApiRoot().replace(/\/+$/, '')

export function apiUrl(path) {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`
  return `${API_ROOT}${normalizedPath}`
}

export const AUTH_TOKEN_KEY = 'buck-press-auth-token'

let unauthorizedHandler = null

export function setUnauthorizedHandler(handler) {
  unauthorizedHandler = handler
  return () => {
    if (unauthorizedHandler === handler) unauthorizedHandler = null
  }
}

function readToken() {
  try {
    return window.localStorage.getItem(AUTH_TOKEN_KEY)
  } catch {
    return null
  }
}

// Every service calls fetch directly, so auth is applied in one place here.
// Installed at module load, not from a React effect: child effects run before
// parent effects, so a page's first request would otherwise go out unsigned.
function installAuthFetch() {
  const originalFetch = window.fetch.bind(window)

  window.fetch = async (input, init = {}) => {
    const url = typeof input === 'string' ? input : input?.url || ''
    if (!url.startsWith(API_ROOT)) return originalFetch(input, init)

    const headers = new Headers(
      init.headers || (typeof input === 'string' ? undefined : input.headers),
    )
    const token = readToken()
    if (token && !headers.has('Authorization')) {
      headers.set('Authorization', `Bearer ${token}`)
    }
    const response = await originalFetch(input, { ...init, headers })
    // Login and password reset return 401 for wrong credentials, not expired sessions.
    const isCredentialCheck = ['/users/login', '/users/reset-password'].some(
      (path) => url.startsWith(apiUrl(path)),
    )
    if (response.status === 401 && !isCredentialCheck) {
      unauthorizedHandler?.()
    }
    return response
  }
}

if (typeof window !== 'undefined' && !window.__buckPressAuthFetchInstalled) {
  window.__buckPressAuthFetchInstalled = true
  installAuthFetch()
}
